import React, { useEffect, useState } from "react";
import { API } from "../backend";
import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  TextField,
  Typography,
  Dialog,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  RadioGroup,
} from "@mui/material";
import { useFlutterwave } from "flutterwave-react-v3";
// import Footer from "../../Component/Footer";
import axios from "axios";
import { Link, Navigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import Logo from "../../images/logo.png";
import ProceedModelModal from "../../Component/ProceedModelModal"; // will need to be changed to account for school ID i think
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import IndividualModel from "../../Component/IndividualModel";
import BulkModel from "../../Component/BulkModel";
import LatePaymentPublicModel from "../../Component/latepaymentform/latepayment_pub_model";
import LateReqModel from "../../Component/latepaymentform/latepayment_model";

const CustomTextField = styled(TextField)({
  // "& .MuiInputBase-input.Mui-disabled": {
  //     color: "red !important",
  //     "-webkit-text-fill-color": "red !important",
  //     borderColor: "red !important"
  //   },
  //   "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
  //     borderColor: "red !important"
  //   }
  "& .MuiInputBase-input.Mui-disabled": {
    color: "rgba(0,0,0,0.6) !important",
    "-webkit-text-fill-color": "rgba(0,0,0,0.6) !important",
    borderColor: "rgba(0,0,0,0.6) !important",
  },
  //   "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
  //     borderColor: "rgba(0,0,0,0.38) !important"
  //   }
});

const ModelLatePaymentForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [numberOfCandidates, setNumberOfCandidates] = useState(null);
  const [ClosingDate, setClosingDate] = useState("");
  const [late, setLate] = useState(false);
  const [price, setPrice] = useState(0);
  const [pinNum, setPinNum] = useState([]);
  const [payerId, setPayerId] = useState("");

  const [openBulk, setOpenBulk] = useState(false);
  const [openIndividual, setOpenIndividual] = useState(false);

  const handleCloseIndividual = () => {
    setOpenIndividual(false);
  };
  const handleCloseBulk = () => {
    setOpenBulk(false);
  };

  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    console.log(e.target.value);
    if (e.target.value === "BULK") {
      setOpenBulk(true);
    }
    if (e.target.value === "INDIVIDUAL") {
      setOpenIndividual(true);
    }
  };

  const navigate = useNavigate();

 

  const config = {
    public_key: process.env.REACT_APP_PUBLIC_KEY,
    tx_ref: Date.now(),
    amount: price,
    currency: "NGN",
    payment_options: "card,mobilemoney,ussd",
    customer: {
      email: email,
      phonenumber: phone,
    },
    customizations: {
      title: "Lagos Pay",
      description: "PAYMENT FOR EXAMINATION (CBS)",
      logo: "https://pbs.twimg.com/media/EtEwgbvXMAQfCXT.jpg",
    },
  };



  return (
    <div >
      <LateReqModel examType={'MODEL SCREENING EXAMINATION'} examName={'Model/Screening College'}  lateRegistrationType="Model/Screening College Late Payment" />
    </div>
  );
};

export default ModelLatePaymentForm;
